import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'

export const BASE_CLASS = `${PAGE_BASE_CLASS}-financing`

export const MONTHS_PER_YEAR = 12

export const FINANCING_MODES = {
  B2C: 'b2c',
  C2C: 'c2c',
  SIMPLIFIED: 'simplified'
}

export const FARE_TYPES = {
  WITHOUT_INSURANCE: 'withoutInsurance',
  WITH_INSURANCE: 'withInsurance'
}

export const FARE_DESCRIPTION_KEYS = {
  [FARE_TYPES.WITHOUT_INSURANCE]: 'PANEL_FINANCING.B2C.FARE_SELECTOR_DESCRIPTION_WITHOUT_INSURANCE',
  [FARE_TYPES.WITH_INSURANCE]: 'PANEL_FINANCING.B2C.FARE_SELECTOR_DESCRIPTION'
}

export const FINANCING_STATUS = {
  LOADING: 'loading',
  ERROR: 'error',
  READY: 'ready'
}

// The lender's own verdict on whether the promotional discount applies to the quote it just returned.
export const DISCOUNT_OPTIONS = {
  WITH: 'withDiscount',
  WITHOUT: 'withoutDiscount'
}

export const ENTRY_MAX_LENGTH = 6

// The lender does not return the b2c redirect URL right away, so we have to poll for it. We read
// once immediately, then retry after 1s, then after 2s, and so on. That adds up to about 45s.
export const LOAN_URL_POLLING = {
  MAX_RETRIES: 10,
  RETRY_INTERVAL: 1000
}

const OPTIONAL = 'FINANCING_INFO.OPTIONAL'
const MANDATORY = 'COMMON.MANDATORY'

export const INSURANCE_LABELS_BY_ID_NAME = {
  CAIXA_WITH_LIFE_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LIFE_INSURANCE'},
  CASUALTY: {
    extraLabel: OPTIONAL,
    label: 'FINANCING_INFO.CASUALTY_AND_LIFE_INSURANCE',
    usesTotalInsuranceAmount: true
  },
  CONFIA_WITH_LIFE_INSURANCE: {label: 'FINANCING_INFO.CONFIA_INFO.PROTECTION_INSURANCE'},
  MOBILIZE_NISSAN_WITH_LIFE_INSURANCE: {extraLabel: MANDATORY, label: 'FINANCING_INFO.PROTECTION_INSURANCE'},
  MOBILIZE_WITH_LIFE_INSURANCE: {extraLabel: MANDATORY, label: 'FINANCING_INFO.PROTECTION_INSURANCE'},
  PAYMENT_PROTECTION: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.PROTECTION_INSURANCE'},
  PPP_BBVA: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.PROTECTION_INSURANCE'},
  SANTANDER_WITH_LIFE_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LIFE_INSURANCE_PLUS'},
  STELLANTIS_WITH_CPI_CASUALTY_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LOAN_INSURANCE'},
  STELLANTIS_WITH_CPI_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LOAN_INSURANCE'},
  STELLANTIS_WITH_SC_GMP_SA_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LOAN_INSURANCE'},
  STELLANTIS_WITH_SC_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LOAN_INSURANCE'},
  STELLANTIS_WITH_SC_INSURANCE_1: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LOAN_INSURANCE'},
  VWFS_WITH_INSURANCE: {extraLabel: OPTIONAL, label: 'FINANCING_INFO.LIFE_AND_UNEMPLOYMENT_INSURANCE'}
}
